module.exports = __webpack_public_path__ + "img/avatar-fellipearb.5c1cdbc7.jpg";